import { render } from "./NewsandmediaPage.vue?vue&type=template&id=20534e69&scoped=true"
import script from "./NewsandmediaPage.vue?vue&type=script&lang=js"
export * from "./NewsandmediaPage.vue?vue&type=script&lang=js"

import "./NewsandmediaPage.vue?vue&type=style&index=0&id=20534e69&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20534e69"]])

export default __exports__